(function() {
  document.addEventListener('DOMContentLoaded', function () {
    console.log("object");
    const buyLocal = document.querySelector('.footer__buy-local');
    const items = Array.from(document.querySelectorAll('.footer__mobile-marquee-item img'));
    if (!buyLocal || items.length === 0) return;

    const fadeDuration = (window.homeHeroSettings && window.homeHeroSettings.animationSpeed) || 500;
    const displayDuration = (window.homeHeroSettings && window.homeHeroSettings.animationDuration) || 3000;
    let currentIndex = 0;
    let timeoutId;

    // Initialiseer items
    items.forEach(item => {
      item.style.position = 'absolute';
      item.style.transition = `opacity ${fadeDuration}ms ease-in-out`;
      item.style.opacity = '0';
    });
    // Laat eerste item zien
    items[currentIndex].style.opacity = '1';

    function cycle() {
      // Verberg huidig
      items[currentIndex].style.opacity = '0';
      // Volgend index
      currentIndex = (currentIndex + 1) % items.length;
      // Toon volgend
      items[currentIndex].style.opacity = '1';
      // Schedule volgende cycle
      timeoutId = setTimeout(cycle, displayDuration);
    }

    // Start cycle na displayDuration
    timeoutId = setTimeout(cycle, displayDuration);

    // Re-init bij resize
    window.addEventListener('resize', () => {
      clearTimeout(timeoutId);
      currentIndex = 0;
      items.forEach(item => (item.style.opacity = '0'));
      items[0].style.opacity = '1';
      timeoutId = setTimeout(cycle, displayDuration);
    });
  });
})();
